import { QueryKey } from '@/constants/shared';
import { nucleusClient } from '@/network/clients/nucleus';
import { useQuery } from '@tanstack/react-query';

export const useVaultTvl = ({ vaultAddress }: { vaultAddress: string }) => {
  const {
    data: tvlData,
    isPending: isPendingTvlData,
    error: tvlDataError,
  } = useQuery({
    queryKey: [QueryKey.TvlData, vaultAddress],
    queryFn: async () => {
      if (!vaultAddress) return {};
      return nucleusClient.getVaultTvl({ vaultAddress });
    },
  });
  return { tvlData, isPendingTvlData, tvlDataError };
};
